import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getINTEGRATIONS2TableStructure";
export const UPDATE_TABLE_DATA = "getINTEGRATIONS2TableData";
// export const UPDATE_CREATE_DATA = "getINTEGRATIONS2CreateData";
export const EXPORT_TABLE_DATA = "exportINTEGRATIONS2TableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINTEGRATIONS2TableStructure";
export const SET_TABLE_DATA = "setINTEGRATIONS2TableData";
export const SET_TABLE_FILTER = "setINTEGRATIONS2TableFilter";
export const SET_TABLE_PAGE = "setINTEGRATIONS2TablePage";
export const SET_TABLE_PERPAGE = "setINTEGRATIONS2TablePerPage";
export const SET_TABLE_SORTBY = "setINTEGRATIONS2TableSortBy";
export const SET_TABLE_SORTORDER = "setINTEGRATIONS2TableSortOrder";
export const SET_EXPORT_LINK = "setINTEGRATIONS2ExportLink";
export const SET_CREATE_DATA = "setINTEGRATIONS2CreateData";
export const SET_INTEGRATION_ID = "setINTEGRATIONS2IntegrationId";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  create_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  integration_id: null,
};

const getters = {
  getINTEGRATIONS2TableState(state) {
    return state.table_state;
  },

  getINTEGRATIONS2TableHeaders(state) {
    return state.table_structure.columns;
  },

  getINTEGRATIONS2TableFilters(state) {
    return state.table_structure.filters;
  },

  getINTEGRATIONS2TablePermissions(state) {
    return state.table_structure.permissions;
  },

  getINTEGRATIONS2TableData(state) {
    return state.table_data.data;
  },

  getINTEGRATIONS2TableProperties(state) {
    return state.table_structure.properties;
  },

  getINTEGRATIONS2ExportUrl(state) {
    return state.export_link;
  },

  getINTEGRATIONS2Customers(state) {
    return state.create_data.customers;
  },

  getINTEGRATIONS2Platforms(state) {
    return state.create_data.platforms;
  },

  getINTEGRATIONS2Validations(state) {
    return state.create_data.validations;
  },
  getINTEGRATIONS2IntegrationId(state) {
    return state.integration_id;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrationsNew")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  // [UPDATE_CREATE_DATA](context) {
  //   return new Promise((resolve) => {
  //     ApiService.post("datahub/integrationsNew/create")
  //       .then(({ data }) => {
  //         context.commit(SET_CREATE_DATA, data);
  //         resolve(data);
  //       })
  //       .catch((data) => {
  //         context.commit(SET_PAGE_LOADING, false);
  //         resolve(data);
  //       });
  //   });
  // },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrationsNew/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/datahub/integrationsNew/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_CREATE_DATA](state, create_data) {
    state.create_data = create_data;
  },
  [SET_INTEGRATION_ID](state, id) {
    state.integration_id = id;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
